<template>
  <div class="navbar">
    <div class="navbar-left">
      <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>
    <div class="navbar-center">
      <el-input class="search-input" placeholder="请输入关键词..." prefix-icon="el-icon-search" />
    </div>
    <div class="navbar-right">
      <div class="date-info">{{ today }}</div>
      <el-badge :value="5" class="notification-badge">
        <i class="el-icon-bell"></i>
      </el-badge>
      <el-dropdown class="avatar-container hover-effect" trigger="hover">
        <div class="user-name">
          <img v-if="avatar" :src="avatar" />
          <span>{{ name || $t('navbar.name') }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="showDialog">
            <span style="display: inline-block;margin-right: 10px;">{{$t('modifyPass.name')}}</span>
            <i style="margin-right: 0 !important;" class="el-icon-edit" />
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: inline-block;margin-right: 10px;">{{$t('navbar.logOut')}}</span>
            <i style="margin-right: 0 !important;" class="el-icon-arrow-right" />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      today: new Date().toLocaleDateString(),
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("FedLogOut");
      this.$router.replace(`/login`);
      location.reload();
    },
    showDialog() {
      this.$emit("showDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  /* background: #fff; */
  /* border-radius: 24px; */
  /* box-shadow: 0 4px 24px rgba(0,0,0,0.04); */
  /* margin: 24px 24px 0 24px; */
  padding: 0 32px;
  position: relative;
  z-index: 10;

  .navbar-left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    .hamburger-container {
    }
    .breadcrumb-container {
      min-width: 0;
    }
  }
  .navbar-center {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .search-input {
      width: 480px;
      border-radius: 28px !important;
      background: #fff !important;
      border: none !important;
      box-shadow: 0 4px 24px rgba(0,0,0,0.06);
      .el-input__inner {
        border-radius: 28px !important;
        background: #fff !important;
        border: none !important;
        font-size: 16px;
        color: #222;
        padding-left: 40px;
        box-shadow: none;
      }
      .el-input__prefix {
        left: 12px;
        color: #b0b8c9;
      }
    }
  }
  .navbar-right {
    display: flex;
    align-items: center;
    gap: 32px;
    .date-info {
      color: $text-secondary;
      font-size: 15px;
    }
    .notification-badge {
      .el-icon-bell {
        font-size: 22px;
        color: $primary;
      }
    }
    .avatar-container {
      display: flex;
      align-items: center;
      cursor: pointer;
      .user-name {
        display: flex;
        align-items: center;
        font-size: 15px;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 8px;
          border: 2px solid #f5f7fa;
        }
        span {
          margin-right: 8px;
          color: #222;
        }
        i {
          color: #b0b8c9;
        }
      }
    }
  }
}
</style>
